import React, {Component} from "react";
import {Button, Col, InputNumber, message, Row, Select, Slider, Typography} from "antd";
import {specimenType} from "../utils/const";
import {get, post} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import {notNull} from "../utils/utils";

window.Buffer = window.Buffer || require("buffer").Buffer;
const { Title } = Typography;

class MainThresh extends Component {

    constructor(props) {
        super(props);

        this.inputScanFolder = "/dev-ssd/thresholding_util";
        this.inputPreviewFolder = '/dev-ssd/saved_previews'

        this.state = {
            imageRGB: [],
            imageLAB: [],
            specimen: specimenType.HNE_TISSUE,
            threshold: [0, 255, 0, 255, 0, 255],
            inputFolder: this.inputScanFolder,
            fileList: [],
            currIndex: 0,
        };

        this.sliderKeys = ["LowL", "HighL", "LowA", "HighA", "LowB", "HighB"];

        this.scanImageHolder = { canvasWidth : 420, canvasHeight : 350 }
        this.previewImageHolder = { canvasWidth : 600, canvasHeight : 326 }
        this.pageSize = 3;

        this.fetchMetaFiles();
        this.fetchThresholdParams();
    }

    componentDidMount() {
    }

    fetchThresholdParams = () => {
        const isScan = this.state.inputFolder === this.inputScanFolder;
        get(`/api/threshold/load_params/?tissue_type=${this.state.specimen}&isScan=${isScan}`)
            .then(thresh => {
                this.processImageLAB(thresh, true);
                this.setState({ threshold: thresh })
            })
            .catch(error => error_manager("Failed to load threshold params", error));
    }

    resetState = () => {
        this.setState({
            imageRGB: [],
            imageLAB: [],
            threshold: [0, 255, 0, 255, 0, 255],
            fileList: [],
            currIndex: 0,
        })
    }

    fetchMetaFiles = () => {
        this.resetState();
        get(`${this.state.inputFolder}/meta.json`)
            .then(meta => {
                this.setState({ fileList: meta.files })
            })
            .catch(error => error_manager("Failed to load meta data", error));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevState.fileList !== this.state.fileList) {
            this.processImageLAB(this.state.threshold, true);
        }

        if (prevState.currIndex !== this.state.currIndex) {
            this.processImageLAB(this.state.threshold, true);
        }

        if (prevState.inputFolder !== this.state.inputFolder) {
            this.fetchMetaFiles();
            this.fetchThresholdParams();
        }

        if (prevState.specimen !== this.state.specimen) {
            this.fetchThresholdParams();
        }
    }

    getSpecimenOptions = () => {
        return Object.keys(specimenType).map((item) => {
            return <Select.Option key={item} value={item}>{item}</Select.Option>
        });
    }

    handleSpecimenChange = (event) => {
        this.setState({ specimen: event });
    }

    onSliderChange = (index, val) => {
        let newThreshold = this.state.threshold;
        if (notNull(val[0])) {
            newThreshold[index] = val[0];
        }
        if (notNull(val[1])) {
            newThreshold[index + 1] = val[1];
        }
        this.setState({ threshold: newThreshold });
        this.processImageLAB(newThreshold, false);
    }

    getSliders = () => {
        const len = this.sliderKeys.length;
        let retVal = [];
        for (let i = 0; i < len; i += 2) {
            retVal.push(<Row>
                <Col span={2}>
                    <Typography>
                        {this.sliderKeys[i]}
                    </Typography>
                </Col>
                <Col span={16}>
                    <Slider range
                        value={[this.state.threshold[i], this.state.threshold[i + 1]]}
                        min={0} max={255}
                        onChange={(e) => this.onSliderChange(i, e)} />
                </Col>
                <Col span={2} offset={1}>
                    <InputNumber style={{ width: '100%' }} size="small"
                        type="number" min={0} max={255}
                        onChange={(e) => this.onSliderChange(i, [e, null])}
                        value={this.state.threshold[i]} />
                </Col>
                <Col span={2} offset={1}>
                    <InputNumber style={{ width: '100%' }} size="small"
                        type="number" min={0} max={255}
                        onChange={(e) => this.onSliderChange(i, [null, e])}
                        value={this.state.threshold[i + 1]} />
                </Col>
            </Row>)
        }

        return <Col span={12}>{retVal}</Col>
    }

    async processImageLAB(threshold, changeRGBImageURL = false) {
        let labArray = []
        let rgbArray = []

        for (let i = 0; i < this.pageSize; i++) {
            if (this.state.currIndex + i > this.state.fileList.length) {
                break;
            }
            if (changeRGBImageURL) {
                const rgb_src = `${this.state.inputFolder}/RGB/${this.state.fileList[this.state.currIndex + i]}`;
                rgbArray.push(rgb_src);
            }
            let img_src = `${this.state.inputFolder}/LAB/${this.state.fileList[this.state.currIndex + i]}`;
            const isScan = this.state.inputFolder === this.inputScanFolder;
            post('/api/threshold/do_threshold/', { "filepath": img_src, "threshVals": threshold, "isScan" : isScan }).then(
                (response) => {
                    labArray.push(response.image);
                    let templabArray = this.state.imageLAB;
                    templabArray[i] = response.image;
                    this.setState({
                        imageLAB: templabArray,
                    });
                }
            )
        }

        if (changeRGBImageURL) {
            this.setState({
                imageRGB: rgbArray,
            });
        }
    }

    getImageComponents = () => {
        let retObj = [];
        let {canvasWidth, canvasHeight} = this.state.inputFolder === this.inputScanFolder ? this.scanImageHolder : this.previewImageHolder;
        for (let i = 0; i < this.pageSize; i++) {
            if (this.state.currIndex + i > this.state.fileList.length - 1) {
                break;
            }
            retObj.push(
                <Col span={8} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Row>
                        <img src={`data:image/jpeg;base64,${this.state.imageLAB[i]}`}
                            width={canvasWidth}
                            height={canvasHeight} alt={"Alt"} style={{ border: "2px solid" }} />
                    </Row>
                    <Row>
                        <img src={`${this.state.imageRGB[i]}`} width={canvasWidth}
                            height={canvasHeight} alt={"Alt"} style={{ border: "2px solid" }} />
                    </Row>
                </Col>
            )
        }
        return retObj;
    }

    handleInputFolderChange = (val) => {
        if (val === 0) {
            this.setState({ inputFolder: this.inputScanFolder })
        } else if (val === 1) {
            this.setState({ inputFolder: this.inputPreviewFolder })
        }
    }

    handleSave = () => {
        const isScan = this.state.inputFolder === this.inputScanFolder;
        get('/api/threshold/save_params/?' +
            `threshold=${this.state.threshold}&tissue_type=${this.state.specimen}&isScan=${isScan}`).then(
                (response) => {
                    message.success("Saved successfully");
                }
            )
    }

    render() {
        return (<Row>
            {this.state.fileList.length > 0 ?
                <Row>
                    {this.getImageComponents()}
                </Row> : <Row ><Title level={2} style={{ display: "flex", justifyContent: "center" }}>No Data Found. Please prepare threshold data</Title></Row>}
            <br />
            <Row>
                {this.getSliders()}
                <Col span={12}>
                    <Row>
                        <Col span={3} offset={3}>
                            <Button disabled={this.state.currIndex < this.pageSize}
                                onClick={() => this.setState({ currIndex: this.state.currIndex - this.pageSize })}>Prev</Button>
                        </Col>
                        <Col span={2}>
                            <Typography>
                                {this.state.currIndex + 1} / {this.state.fileList.length}
                            </Typography>
                        </Col>
                        <Col span={3}>
                            <Button
                                disabled={this.state.currIndex > this.state.fileList.length - this.pageSize - 1}
                                onClick={() => this.setState({ currIndex: this.state.currIndex + this.pageSize })}>Next</Button>
                        </Col>
                        <Col span={4} offset={2}>
                            <Select
                                value={this.state.inputFolder === this.inputScanFolder ? "Scan" : "Preview"}
                                style={{
                                    width: 120,
                                }}
                                onChange={this.handleInputFolderChange}
                            >
                                <Select.Option key={0} value={0}>{"Scan"}</Select.Option>
                                <Select.Option key={1} value={1}>{"Preview"}</Select.Option>
                            </Select>
                        </Col>
                        <Col span={4} offset={1}>
                            <Select
                                value={this.state.specimen}
                                style={{
                                    width: 120,
                                }}
                                onChange={this.handleSpecimenChange}
                            >
                                {this.getSpecimenOptions()}
                            </Select>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col span={5} offset={10}>
                            <Button onClick={this.handleSave}>Save to Config</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Row>
        );
    }
}

export default MainThresh
